import React from "react";
import styles from "./custom-daterange-picker.module.css";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;

const CustomDateRangePicker = ({ value, onChange, dateFormat = "MMM DD, YYYY" }) => (
  <div className={styles.CustomDateRangePicker}>
    <RangePicker
      value={value}
      onChange={onChange}
      allowEmpty={false}
      allowClear={false}
      nextIcon={null}
      suffixIcon={null}
      prefix={
        <img
          src="/assets/images/calendar.svg"
          className={styles.customCalendarIcon}
          alt="calendarIcon"
        />
      }
      className={styles.customRangePicker}
      format={dateFormat}
      separator={
        <div
          style={{
            fontWeight: 500,
            margin: "5px",
            padding: 0,
          }}
        >
          –
        </div>
      }
    />
  </div>
);

export default CustomDateRangePicker;
